import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import {ImageUploader} from '../uploaders';
import {EditorDialog} from '../editor-components';
import ExhibitorSelect from './exhibitor-select';

/** @class EditGiftCardDialog
  * A component for editing an existing gift card.
  * @prop {Array} exhibitors - the exhibitors in the show
  * @prop {URL} dataURL - the Firebase url for gift cards
  * @prop {bool} show - a boolean flag indicating if the dialog visibility
  * @prop {function} onChange - callback to trigger on change events
  */
export default class EditGiftCardDialog extends Component {
  /** @constructor
    * Constructs a new EditGiftCardDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      exhibitorID: props.giftCard.exhibitorID || '',
      deal: props.giftCard.deal || '',
      code: props.giftCard.code || '',
      image: props.giftCard.image || ''
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @method componentWillReceiveProps
    * Responds to changing props (most likely
    * when a new user has been selected).
    */
  componentWillReceiveProps(props) {
    this.setState({
      exhibitorID: props.giftCard.exhibitorID || '',
      deal: props.giftCard.deal || '',
      code: props.giftCard.code || '',
      image: props.giftCard.image || ''
    });
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method handleSelect
    * Applies changes to the user state from a select input
    * @param {InputEvent} event - the triggering event
    */
  handleSelect(event) {
    const target = event.target;
    const value = target.value;
    this.setState({
      exhibitorID: value
    }, () => {
      var exhibitor = this.props.exhibitors.find(exhibitor => exhibitor.id === value);
      var exhibitorName = exhibitor ? exhibitor.brand || exhibitor.company || "" : "";
      var updates = {
        [`${this.props.dataURL}/${this.props.giftCard.id}/exhibitorID`]: value,
        [`${this.props.dataURL}/${this.props.giftCard.id}/exhibitor`]: exhibitorName
      }
      firebase.database().ref().update(updates);
    });
  }
  /** @method handleImageUpload
    * Callback for updating an image url.
    * @param {url} url - the new image location.
    */
  handleImageUpload(url) {
    this.setState({
      image: url
    }, () => firebase.database()
          .ref(this.props.dataURL)
          .child(this.props.giftCard.id)
          .child('image')
          .set(url)
    );
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur(event) {
    const target = event.target;
    const name = target.name;
    firebase.database()
      .ref(this.props.dataURL)
      .child(this.props.giftCard.id)
      .child(name)
      .set(this.state[name]);
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Edit Gift Card</h3>
        <p className="info-panel">
          Changes are automatically applied
        </p>
        <div className="input-group">
          <ExhibitorSelect
            name="exhibitorID"
            value={this.state.exhibitorID}
            exhibitors={this.props.exhibitors}
            onChange={this.handleSelect}
            />
        </div>
        <div className="input-group">
          <label htmlFor="deal">Deal</label>
          <input name="deal" type="text"
            value={this.state.deal}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="code">Code</label>
          <input name="code" type="text"
            value={this.state.code}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <ImageUploader name="image"
          value={this.state.image}
          dataURL={this.props.dataURL}
          onUpload={this.handleImageUpload}
          />
      </EditorDialog>
    );
  }
}

EditGiftCardDialog.propTypes = {
  exhibitors: PropTypes.array.isRequired,
  dataURL: PropTypes.string.isRequired,
  giftCard: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/edit-gift-card-dialog.js